<template>
  <div class="weightloss">
        <b-container fluid >
            <b-row class="mycontainer-main " >
                <b-col cols="12" md="4" class="pl-5 leftcontent" >
                    <h1> {{ $t('weightloss.jumbo-title') }} </h1>
                    <h1 style="font-weight: 900; font-size: 2em;"> {{ $t('weightloss.jumbo-desc1') }} </h1>
                    <b-button squared variant="outline-dark" class="mt-3 shadow"  @click="goBack"> {{ $t('common.goback') }}  </b-button>   
                </b-col>

                <b-col cols="12" md="7" class="py-3 ">

                    <b-row v-if="existingShow" class="existing" align-v="center">
                        <b-col class="align-contents-center">
                            <b-card class="shadow"
                            >
                                <b-card-title>{{ $t('weightloss.q1') }}</b-card-title>
                                <b-button squared variant="outline-dark"  style="min-width: 10vw;" class="mt-3 shadow" @click="setExisting">{{ $t('common.yes') }} </b-button>
                                <b-button squared variant="outline-light" style="min-width: 10vw; background-color: black;" class="mt-3 shadow" @click="setNew">{{ $t('weightloss.no') }} </b-button>
                            </b-card>
                        </b-col>
                    </b-row>

            

                <!-- show the meat of ideal protein here after they agree -->

                <b-row v-if="newclient" class="wtsection3" align-v="center">
                    <b-col class="h-100 ">
                        <b-card class="shadow"                             
                        img-top
                            :img-src="require('../assets/images/services/wl_1.png')" >
                            <b-card-title>{{ $t('weightloss.history') }}</b-card-title>
                            <b-card-text>{{ $t('weightloss.history_desc') }}</b-card-text>
                        </b-card>
                    </b-col>
                </b-row>

                <b-row v-if="newclient" class="wtsection2 mt-2  px-3" align-v="center">
                    <b-col cols="12" class="col-sm-3 text-center">
                        <h6 style="font-weight: 900; font-size: 1.3em; ">{{ $t('weightloss.r1') }}</h6>
                    </b-col>
                    <b-col cols="12" class="col-sm-3 text-center">
                        <h6 style="font-weight: 900; font-size: 1.3em; ">{{ $t('weightloss.r2') }}</h6>
                    </b-col>
                    <b-col  cols="12" class="col-sm-3 text-center">
                        <h6 style="font-weight: 900; font-size: 1.3em; ">{{ $t('weightloss.r3') }}</h6>
                    </b-col>
                    <b-col cols="12" class="col-sm-3 text-center">
                        <h6 style="font-weight: 900; font-size: 1.3em; ">{{ $t('weightloss.r4') }}</h6>
                    </b-col>
                </b-row>

                
                <b-row v-if="newclient" class="wtsectiontitles mt-3" align-v="center">
                    <b-col >
                        <b-card-group deck>
                        <b-card class="shadow">
                            <b-card-title>{{ $t('weightloss.topreasons') }}</b-card-title>                        
                                <b-list-group flush>
                                    <b-list-group-item>"{{ $t('weightloss.rw1') }}"</b-list-group-item>
                                    <b-list-group-item>"{{ $t('weightloss.rw2') }}"</b-list-group-item>
                                    <b-list-group-item>"{{ $t('weightloss.rw3') }}"</b-list-group-item>
                                    <b-list-group-item>"{{ $t('weightloss.rw4') }}"</b-list-group-item>
                                    <b-list-group-item>"{{ $t('weightloss.rw5') }}"</b-list-group-item>
                                </b-list-group>
                        </b-card>

                         <b-card class="shadow">
                            <b-card-title>{{ $t('weightloss.howitworks') }}</b-card-title>                        
                                <b-list-group flush>
                                    <b-list-group-item>{{ $t('weightloss.h1') }}</b-list-group-item>
                                    <b-list-group-item>{{ $t('weightloss.h2') }}</b-list-group-item>
                                    <b-list-group-item>{{ $t('weightloss.h3') }}</b-list-group-item>
                                    <b-list-group-item>{{ $t('weightloss.h4') }}</b-list-group-item>
                                    <b-list-group-item>{{ $t('weightloss.h5') }}</b-list-group-item>
                                </b-list-group>
                        </b-card>
                    </b-card-group>
                    </b-col>
                </b-row>

                 <b-row v-if="newclient" class="my-2"> 
                     <b-col class="text-center">
                        <h3 style="font-weight: 900; font-size: 2em;"> {{ $t('weightloss.help') }}</h3> 
                    </b-col>
                </b-row>

                <b-row v-if="newclient"> 
                        <b-col class="text-center">
                            <b-button squared variant="dark" style="background-color: black; min-width: 10vw" size="md" class="shadow mt-2" to="/appointment">{{ $t('weightloss.ctabutton') }}</b-button>
                        </b-col>  
                    </b-row> 
                    <!-- end of new client -->
            
                <b-row v-if="existing" class="newclient" align-v="center">
                    <b-col cols="12" class="col-sm-12">
                        <b-card-group deck>
                            <b-card
                            img-top
                            :img-src="require('../assets/images/idealproteinfoods.jpg')" 
                            >
                                <b-card-title> {{ $t('weightloss.orderproducts') }}</b-card-title>
                                <b-card-text>{{ $t('weightloss.orderproducts_desc') }}</b-card-text>
                                <b-button squared variant="dark" style="background-color: black; min-width: 10vw" size="md" class="shadow mt-2" to="/appointment">{{ $t('weightloss.ordercta') }}</b-button>
                            </b-card>

       
                        </b-card-group>
                    </b-col>
                    <b-col>
                    </b-col>
                </b-row> 


            </b-col> 
            </b-row>            
        </b-container>
  </div>
</template>

<script>

// const enData = [
//           {name: "coming soon",
//           date: "june 1, 2020",
//           type: "",
//           img: "https://placekitten.com/g/350/450",
//           desc: "thank you for your patience!",
//           link: "",
//           },
// ]

// const frData = [
//           {name: "coming soon",
//           date: "june 1, 2020",
//           type: "",
//           img: "https://placekitten.com/g/350/450",
//           desc: "thank you for your patience!",
//           link: "",
//           }
// ]


export default {
  name: 'weightloss',
  data () {
    return {
      event: '',
      wl: [],
      existingShow: true,
      existing: false,
      newclient: false,
    }
  },
  methods: {
    goBack (){
      this.$router.go(-1)
  },
    getData () {
        if (this.$i18n.locale == 'fr'){
          this.tutorials = frData;
        }
        else this.tutorials = enData
         }
    ,setExisting() {
        this.existing=true
        this.newclient = false;
        this.existingShow = false;
    }
    ,setNew() {
        this.existing=false
        this.newclient = true;
        this.existingShow = false;
    }
//   serviceDetail(n) {
//       var serv = n
//       this.$router.push({ name: 'servicedetail', params: { service: n } })
//   }
  },
  computed: {
     locale(){
          return this.$i18n.locale
      },
  },
  mounted() { 
      this.getData() 
  },
  watch: {
      locale: function (newLocale, oldLocale) {
        this.getData()
      }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mycontainer-main {
    min-height:  calc(90vh);
}
.leftcontent {
    padding-top: 30vh;
    padding-bottom: 10vh;
}
.card-img-top {
    width: 100%;
    height: 15rem;
    object-fit: cover;
}
.wtlossbackground{
    background-image:url('../assets/images/waiting_room_front_3.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    min-height: 35vh;    
}
.wtsection1{
    min-height: 35vh;    
}
.wtsection2{
    min-height: 20vh;    
}
.existing {
    min-height: 80vh;
    background-image:url('../assets/images/idealprotein.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;    
}
.newclient {
    min-height: 80vh;
}
.bcwt {
    background-image:url('../assets/images/services/wl_1.png');
    background-repeat: no-repeat;
    background-position: top;
    background-size: cover;     
}
</style>



// WEBPACK FOOTER //
// src/pages/WeightLoss.vue